import React from 'react';
import { Link as RouterLink } from 'react-router-dom'; // For page navigation
import { Link as ScrollLink } from 'react-scroll'; // For smooth scrolling

const Navbar = () => {
  return (
    <header className="bg-black text-white py-4 px-6 fixed w-full top-0 z-50 shadow-md">
      <nav className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo and Name */}
        <div className="flex items-center space-x-3">
          <img
            src="/alpha.png"
            alt="AlphaQ Logo"
            className="h-12 w-12 animate-fade-in"
          />
          <span className="text-xl md:text-2xl font-bold tracking-wide animate-fade-in">
            AlphaQ
          </span>
        </div>

        {/* Navigation Links */}
        <ul className="flex space-x-6 text-sm md:text-base">
        <li className="hover:text-gray-400 transition">
  <RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    Home
  </RouterLink>
</li>
<li className="hover:text-gray-400 transition">
<RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top: 660, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    Principles
  </RouterLink>
</li>

<li className="hover:text-gray-400 transition">
<RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top: 1500, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    Products
  </RouterLink>
</li>



<li className="hover:text-gray-400 transition">
<RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top: 3800, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    About
  </RouterLink>
</li>

<li className="hover:text-gray-400 transition">
<RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top: 4600, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    Industry & Applications
  </RouterLink>
</li>


<li className="hover:text-gray-400 transition">
<RouterLink
    to="/"
    onClick={() => {
      window.scrollTo({ top:6300, behavior: "smooth" }); // Scroll to the top of the page
    }}
    className="hover:text-gray-400 transition"
  >
    Contact
  </RouterLink>
</li>

        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
